import React from 'react'

const ArrowRightUp = ({ fill = 'currentColor', width='16', height='16' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3699_10052)">
        <path d="M8.66667 5.21867V13.3333H7.33333V5.21867L3.75733 8.79467L2.81467 7.852L8 2.66667L13.1853 7.852L12.2427 8.79467L8.66667 5.21867Z" fill={fill}/>
      </g>
      <defs>
        <clipPath id="clip0_3699_10052">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  )
}

export default ArrowRightUp
